<app-page-loader></app-page-loader>
<app-header></app-header>
<router-outlet></router-outlet>
<div id="footer"></div>
